import type { ReactNode } from "react";

import { Flex } from "@mantine/core";

interface GuidedFlowsPanelProps {
    guide: ReactNode;
}

export function GuidedFlowsPanel({ guide }: GuidedFlowsPanelProps) {
    return (
        <Flex pos="absolute" inset={0}>
            {guide}
        </Flex>
    );
}
